import { ENTITY_LABEL, ENTITY_PLURAL_LABEL } from "../../Helpers/Labels/EntityLabel"

const CommanVideos = [
    {
        text: "Welcome! Get Started",
        description: `Welcome to CodelessONE! This video will help you get started with the platform. It will walk you through the basics of the application, including how to create objects, properties, and object relations. It will also show you how to set up portals and roles, ensuring that your application is tailored to your needs. `,
        tag: "Video",
        keyword: "Comman",
        videoUrl: "https://youtu.be/XoA-54uVPxk",
        order: 1
    },
    // {
    //     text: "New Release!",
    //     description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
    //     tag: "Article",
    //     keyword: "Comman",
    //     image: "https://ideadatalakestorage.blob.core.windows.net/designerresources/images/NoSubscriptionImage.png",
    //     order: 3
    // }
]

export const CommanArticles = [
    { text: "Getting Started", externalUrl: "https://www.codelessone.com/" },
    { text: "Knowledge Base", externalUrl: "https://www.codelessone.com/" },
    { text: "Integration and API Documentation", externalUrl: "https://www.codelessone.com/" },
    { text: "Rights Administration", externalUrl: "https://www.codelessone.com/" }
]

export const contactUsOptions = [
    { text: "Email us", icon: "far fa-envelope" },
    { text: "Request a call", icon: "far fa-phone" },
    { text: "Submit an idea", icon: "far fa-lightbulb pe-1" },
    { text: "Submit a ticket", icon: "far fa-message-lines" },
]

export const Objects = {
    "Article": [
        {
            text: `What is an ${ENTITY_LABEL}?`,
            description: `In CodelessONE, an "Object" is a foundational element used to organize and structure data. Think of it as a digital drawer or compartment where specific sets of information are grouped together. Just as you'd use a folder on a computer to store related files, an "Object" in CodelessONE groups related data, making it easier to access, modify, and manage. This organization ensures clarity and efficiency when working with various data points within the platform.`,
            tag: "Article",
            keyword: `${ENTITY_PLURAL_LABEL}`,  
            image: "https://ideadatalakestorage.blob.core.windows.net/designerresources/images/NoSubscriptionImage.png",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: `How to work with ${ENTITY_PLURAL_LABEL}?`,
            description: `To work with objects in CodelessONE, start by accessing the "App Model Tab" through the settings icon. Here, you'll find core components like Objects, Properties, Roles, and Portals. To create an object, either manually click on "+ New Object" and fill in the relevant details or use the "Alice AI" button for automated object and property suggestions. After selecting your preferences, always ensure to click the "Update App" button to see the changes in your App's workspace. `,
            tag: "Article",
            keyword: `${ENTITY_PLURAL_LABEL}`,
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: `How to personalize my ${ENTITY_PLURAL_LABEL}?`,
            description: `In CodelessONE, personalizing objects is straightforward. Start by navigating to the 'App Model Tab' via 'Application Settings'. Here, you can update the object name, adjust its label for better clarity in the workspace, choose or change its icon for easier visual identification, and provide or modify its description. You also have the option to customize the plural label of the object. After making all adjustments, remember to click 'Save' and then 'Update App' to ensure your changes are reflected in the application, keeping it intuitive and user centric. `,
            tag: "Article",
            keyword: `${ENTITY_PLURAL_LABEL}`,
            image: "https://ideadatalakestorage.blob.core.windows.net/designerresources/images/NoSubscriptionImage.png",
            learnMoreUrl: "https://www.codelessone.com/",
        }
    ],
    "Video": [
        ...CommanVideos,
        // ...[{
        //     text: `How to: ${ENTITY_LABEL}`,
        //     description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //     tag: "Video",
        //     keyword: `${ENTITY_PLURAL_LABEL}`,
        //     videoUrl: "https://codelessone.wistia.com/medias/ym3elw1dje",
        //     learnMoreUrl: "https://www.codelessone.com/",
        //     order: 2
        // }]
    ],
    keyword: `${ENTITY_PLURAL_LABEL}`
}

export const Properties = {
    "Article": [
        {
            text: "What are Properties?",
            description: `In CodelessONE, "Properties" are specific data fields or attributes associated with an Object. They help define and provide detailed information about that Object. For example, for a "Customer" Object, Properties might include "Name", "Email Address", or "Contact Number". Essentially, Properties capture the various aspects or characteristics of an Object within the application.`,
            tag: "Article",
            keyword: "Properties",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to work with Properties?",
            description: `In CodelessONE, managing properties starts by accessing the "App Model Tab" through "Application settings". Once there, select the desired object to enhance. You can manually add properties by clicking the "Add New Property" button, entering a name, choosing a type, and finalizing with "Create". Alternatively, use the "Alice AI" feature for automated property recommendations based on the object's name. After making selections, it's crucial to hit the "Update App" button to apply changes, ensuring a customized experience within your application.`,
            tag: "Article",
            keyword: "Properties",
            image: "https://ideadatalakestorage.blob.core.windows.net/designerresources/images/NoSubscriptionImage.png",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to personalize my Properties?",
            description: `In CodelessONE, to personalize properties, navigate to the 'Edit Property' section by clicking on the desired property name. This interface allows adjustments to general elements, such as setting default values, tooltips, and descriptions. Depending on the property type, you can also define specific attributes like formulas, character limits, and default dates or times. After tailoring your properties, ensure to click 'Save' and then 'Update App' to apply and reflect all modifications, aligning them with your application's needs and enhancing user experience. `,
            tag: "Article",
            keyword: "Properties",
            learnMoreUrl: "https://www.codelessone.com/",
        }
    ],
    "Video": [
        ...CommanVideos,
        // ...[{
        //     text: "How to: Properties",
        //     description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //     videoUrl: "https://codelessone.wistia.com/medias/ym3elw1dje",
        //     tag: "Video",
        //     keyword: "Properties",
        //     learnMoreUrl: "https://www.codelessone.com/",
        //     order: 2
        // }]
    ],
    keyword: "Properties"
}

export const LinkedEntity = {
    "Article": [
        {
            text: "What are Object Relations?",
            description: `Object Relations in an application define the intricate connections between different data objects, establishing a cohesive data structure. These relationships utilize three primary cardinalities: One-to-One, One-to-Many, and Many-to-Many. Each cardinality dictates a unique way in which objects can be interlinked, ensuring efficient data organization and retrieval. `,
            tag: "Article",
            keyword: "Linked Entities",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to work with Object Relations?",
            description: `To manage Object Relations in the App Model, you can either manually create relations by selecting two objects, determining their cardinality, and naming the relation, or use Alice AI, which provides tailored relation suggestions based on your app's framework. After setting up the desired relations, it's crucial to click "Update App" to integrate these changes into your application.`,
            tag: "Article",
            keyword: "Linked Entities",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to personalize my Object Relations?",
            description: `In the App Model, personalizing object relations enhances user experience. To edit relations, access the 'Linked Object' section. Here, you can adjust reference properties, especially for One-to-Many cardinalities, modify cardinality types, redefine relation names, and update relation labels. After adjusting, always save and click "Update App" to integrate changes. Properly structured relations ensure the app aligns with user requirements. `,
            tag: "Article",
            keyword: "Linked Entities",
            learnMoreUrl: "https://www.codelessone.com/",
            image: "https://ideadatalakestorage.blob.core.windows.net/designerresources/images/NoSubscriptionImage.png"
        }
    ],
    "Video": [
        ...CommanVideos,
        // ...[{
        //     text: "How to: ObjectRelations",
        //     description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //     tag: "Video",
        //     keyword: "Linked Entities",
        //     learnMoreUrl: "https://www.codelessone.com/",
        //     videoUrl: "https://codelessone.wistia.com/medias/ym3elw1dje",
        //     order: 2
        // }]
    ],
    keyword: "Linked Entities"
}

export const Pages = {
    "Article": [
        {
            text: "What are Pages?",
            description: `In CodelessONE, "Pages" are the primary interface through which users interact with the application. They are the visual representation of the application's data and functionality. Pages are composed of various elements, including objects, properties, and portals. These elements are arranged in a way that ensures a seamless user experience. `,
            tag: "Article",
            keyword: "Pages",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to work with Pages?",
            description: `To work with pages in CodelessONE, start by accessing the "App Model Tab" through the settings icon. Here, you'll find core components like Objects, Properties, Roles, and Portals. To create a page, either manually click on "+ New Page" and fill in the relevant details or use the "Alice AI" button for automated page suggestions. After selecting your preferences, always ensure to click the "Update App" button to see the changes in your App's workspace. `,
            tag: "Article",
            keyword: "Pages",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to personalize my Pages?",
            description: `In CodelessONE, personalizing pages is straightforward. Start by navigating to the 'App Model Tab' via 'Application Settings'. Here, you can update the page name, adjust its label for better clarity in the workspace, choose or change its icon for easier visual identification, and provide or modify its description. You also have the option to customize the plural label of the page. After making all adjustments, remember to click 'Save' and then 'Update App' to ensure your changes are reflected in the application, keeping it intuitive and user centric. `,
            tag: "Article",
            keyword: "Pages",
            learnMoreUrl: "https://www.codelessone.com/",
        }
    ],
    "Video": [
        ...CommanVideos,
        // ...[{
        //     text: "How to: Pages",
        //     description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
        //     tag: "Video",
        //     keyword: "Pages",
        //     learnMoreUrl: "https://www.codelessone.com/",
        //     videoUrl: "https://codelessone.wistia.com/medias/ym3elw1dje",
        //     order: 2
        // }]
    ],
    keyword: "Pages"
}

export const Roles = {
    "Article": [
        {
            text: "What are Roles?",
            description: `In CodelessONE, roles represent predefined sets of permissions that delineate the range of actions a user can execute within the system. By categorizing users into specific roles, the platform ensures that everyone can access and modify only the sections and features pertinent to their assigned tasks and responsibilities, thereby maintaining security and workflow efficiency.`,
            tag: "Article",
            keyword: "Roles",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to work with Roles?",
            description: `In CodelessONE, roles ensure users have access tailored to their responsibilities. While default roles like Admin and Contributor are provided, you can add new ones using '+New Role'. Each role's permissions can be broadly defined or fine-tuned at the object and field levels. After setting permissions, always save and click "Update App" to apply the changes, ensuring a secure and efficient user experience. `,
            tag: "Article",
            keyword: "Roles",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to personalize my Roles?",
            description: `In CodelessONE, roles are tailored tools ensuring that users access features relevant to their duties. By selecting a specific role, you can refine its name and delve into its permissions, adjusting access levels for various objects, from 'Full Access' to 'Read Only'. Once the necessary adjustments are made, always save your changes, and promptly update the app. This ensures that your modifications are consistently applied. After solidifying these role configurations, you can efficiently assign users to these specialized roles, safeguarding that each user interacts with the application within their designated permissions, enhancing both security and operational efficiency. `,
            tag: "Article",
            keyword: "Roles",
            learnMoreUrl: "https://www.codelessone.com/",
        }
    ],
    "Video": [
        ...CommanVideos,
        ...[{
            text: "How to: Roles",
            description: `In CodelessONE, roles represent predefined sets of permissions that delineate the range of actions a user can execute within the system. By categorizing users into specific roles, the platform ensures that everyone can access and modify only the sections and features pertinent to their assigned tasks and responsibilities, thereby maintaining security and workflow efficiency.`,
            tag: "Video",
            keyword: "Roles",
            learnMoreUrl: "https://www.codelessone.com/",
            videoUrl: "https://youtu.be/vp-ugYpycs8",
            order: 2
        }]
    ],
    keyword: "Roles"
}

export const Portals = {
    "Article": [
        {
            text: "What are Portals?",
            description: `Portals in CodelessONE are designated areas within an application, designed to display specific data tailored to certain users or teams. They act as individualized windows into the application, ensuring streamlined access to relevant information. For example, an HR team might have a portal displaying only HR-related objects, while a project management team might see objects related to projects, tasks, and milestones. By setting up distinct portals, organizations can enhance collaboration, reduce clutter, and ensure that each team or user interacts with only the data pertinent to their role or function. `,
            tag: "Article",
            keyword: "Portals",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to work with Portals?",
            description: `In CodelessONE, portals are tailored views that display specific application data for designated teams or departments. To set one up, simply click on '+New Portal', give it a name, choose an icon, and describe its purpose. Once created, you can select the relevant objects for display under 'Object Selection'. Remember, by default, all objects are chosen, so deselect any that aren't pertinent to the portal's intended users. After finalizing your selections, hit 'Save' and then 'Update App' to make your portal live. These portals not only streamline data access but also bolster collaboration by ensuring real-time data synchronization across different teams. `,
            tag: "Article",
            keyword: "Portals",
            learnMoreUrl: "https://www.codelessone.com/",
        },
        {
            text: "How to personalize my Portals?",
            description: `In CodelessONE, personalizing a portal ensures it meets user-specific needs. Start by selecting the desired portal from the 'App Model'. Once inside, you can choose which objects to display, tailoring the portal's content. The 'General Settings' allow modifications to the portal's name, icon, and description for clarity. Under 'Navigation Bar and Logo', decide the navigation bar's position, set the default landing page, and update logos to align with branding. After making these adjustments, always save and then 'Update App' to finalize changes, creating a tailored portal environment that enhances user interaction and data accessibility. `,
            tag: "Article",
            keyword: "Portals",
            learnMoreUrl: "https://www.codelessone.com/",
        }
    ],
    "Video": [
        ...CommanVideos,
        ...[{
            text: "How to: Portals",
            description: `Portals in CodelessONE are designated areas within an application, designed to display specific data tailored to certain users or teams. They act as individualized windows into the application, ensuring streamlined access to relevant information. For example, an HR team might have a portal displaying only HR-related objects, while a project management team might see objects related to projects, tasks, and milestones. By setting up distinct portals, organizations can enhance collaboration, reduce clutter, and ensure that each team or user interacts with only the data pertinent to their role or function. `,
            tag: "Video",
            keyword: "Portals",
            learnMoreUrl: "https://www.codelessone.com/",
            videoUrl: "https://youtu.be/ZWcL1hYPeqo",
            order: 2
        }]
    ],
    keyword: "Portals"
}

export const helpCenterContent = [
    Objects,
    Properties,
    LinkedEntity,
    Pages,
    Roles,
    Portals
]
